/**
 * Corporate Form - Script
 * Opens modal ONLY when URL contains #bulk-corporate
 * Submits to "Corporate Leads" sheet in Google Spreadsheet
 * Includes City, Where Heard, UTM tracking, and Thank You page redirect
 */

(function() {
    'use strict';

    // ============================================
    // CONFIGURATION
    // ============================================
    const CONFIG = {
        googleSheetsURL: 'https://script.google.com/macros/s/AKfycbxrZm1UOqAeHd7uHT6_rxPKPkkIBZTsUUQYPvg9AGOggepJLkZlizmwIZ64hhFGXczC/exec',
        sheetName: 'Corporate Leads',
        triggerHash: '#bulk-corporate', // Modal opens ONLY when this hash is in the URL
        thankYouPage: 'https://www.rabitat.com/pages/corporate-submission',
    };

    // ============================================
    // UTM HELPER
    // ============================================
    function getUTMParams() {
        const params = new URLSearchParams(window.location.search);
        return {
            utm_source:   params.get('utm_source')   || '',
            utm_medium:   params.get('utm_medium')   || '',
            utm_campaign: params.get('utm_campaign') || '',
            utm_term:     params.get('utm_term')     || '',
            utm_content:  params.get('utm_content')  || '',
        };
    }

    // ============================================
    // FORM FUNCTIONALITY
    // ============================================
    let elements = {};

    function initForm() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', setupForm);
        } else {
            setupForm();
        }
    }

    function setupForm() {
        elements = {
            form: document.getElementById('corpModalForm'),
            overlay: document.getElementById('corpModalOverlay'),
            closeBtn: document.getElementById('corpModalCloseBtn'),
            submitBtn: document.getElementById('corpModalSubmitBtn'),
            successMessage: document.getElementById('corpModalSuccessMessage'),
            successCloseBtn: document.getElementById('corpModalSuccessCloseBtn'),
            submitText: document.querySelector('.corp-modal-submit-text'),
            submitLoader: document.querySelector('.corp-modal-submit-loader')
        };

        if (!elements.form) {
            return;
        }

        attachFormListeners();
        attachLinkHandlers();
        checkHashOnLoad();
    }

    // ============================================
    // HASH-BASED TRIGGER
    // ============================================

    // Check if page loaded with #bulk-corporate in URL
    function checkHashOnLoad() {
        if (window.location.hash === CONFIG.triggerHash) {
            openForm();
            // Clean the hash from URL without page reload
            history.replaceState(null, null, window.location.pathname + window.location.search);
        }
    }

    // Listen for hash changes (when user clicks a link with #bulk-corporate)
    window.addEventListener('hashchange', function() {
        if (window.location.hash === CONFIG.triggerHash) {
            openForm();
            history.replaceState(null, null, window.location.pathname + window.location.search);
        }
    });

    // Intercept clicks on links with href="#bulk-corporate" to prevent page jump
    function attachLinkHandlers() {
        document.addEventListener('click', function(e) {
            const link = e.target.closest('a');
            if (link && link.getAttribute('href') === CONFIG.triggerHash) {
                e.preventDefault();
                openForm();
            }
        });
    }

    // ============================================
    // FORM LISTENERS
    // ============================================
    function attachFormListeners() {
        elements.form.addEventListener('submit', handleFormSubmit);

        if (elements.closeBtn) {
            elements.closeBtn.addEventListener('click', closeForm);
        }

        if (elements.successCloseBtn) {
            elements.successCloseBtn.addEventListener('click', closeForm);
        }

        if (elements.overlay) {
            elements.overlay.addEventListener('click', function(e) {
                if (e.target === elements.overlay) {
                    closeForm();
                }
            });
        }

        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape') {
                closeForm();
            }
        });

        const phoneInput = document.getElementById('corpModalPhone');
        if (phoneInput) {
            phoneInput.addEventListener('input', function() {
                this.value = this.value.replace(/[^0-9]/g, '').slice(0, 10);
            });
        }
    }

    async function handleFormSubmit(e) {
        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        const formData = getFormData();
        setLoadingState(true);

        try {
            if (CONFIG.googleSheetsURL) {
                await submitToGoogleSheets(formData);
            } else {
                await new Promise(resolve => setTimeout(resolve, 1500));
            }

            // Redirect to Thank You page
            window.location.href = CONFIG.thankYouPage;

        } catch (error) {
            console.error('Corp Form: Submission error:', error);
            alert('Sorry, there was an error submitting your form. Please try again.');
            setLoadingState(false);
        }
    }

    function validateForm() {
        const name      = document.getElementById('corpModalName')?.value.trim()  || '';
        const phone     = document.getElementById('corpModalPhone')?.value.trim() || '';
        const email     = document.getElementById('corpModalEmail')?.value.trim() || '';
        const city      = document.getElementById('corpModalCity')?.value.trim()  || '';
        const units     = document.getElementById('corpModalUnits')?.value        || '';
        const inquiry   = document.getElementById('corpModalInquiry')?.value      || '';
        const heardFrom = document.getElementById('corpModalHeard')?.value        || '';

        if (!name)    { alert('Please enter your name'); return false; }
        if (!phone)   { alert('Please enter your phone number'); return false; }
        if (phone.length !== 10) { alert('Phone number must be exactly 10 digits'); return false; }
        if (!/^[0-9]{10}$/.test(phone)) { alert('Phone number must contain only digits'); return false; }
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { alert('Please enter a valid email address'); return false; }
        if (!city)    { alert('Please enter your city'); return false; }
        if (!units)   { alert('Please select number of units'); return false; }
        if (!inquiry) { alert('Please select inquiry type'); return false; }
        if (!heardFrom) { alert('Please select where you heard about us'); return false; }

        return true;
    }

    function getFormData() {
        const utms = getUTMParams();

        return {
            // Form fields
            name:         document.getElementById('corpModalName').value.trim(),
            phone:        '+91' + document.getElementById('corpModalPhone').value.trim(),
            email:        document.getElementById('corpModalEmail').value.trim(),
            city:         document.getElementById('corpModalCity').value.trim(),
            units:        document.getElementById('corpModalUnits').value,
            inquiry:      document.getElementById('corpModalInquiry').value,
            heardFrom:    document.getElementById('corpModalHeard').value,
            message:      document.getElementById('corpModalMessage').value.trim(),

            // UTM / tracking
            landingPage:  window.location.href,
            utm_source:   utms.utm_source,
            utm_medium:   utms.utm_medium,
            utm_campaign: utms.utm_campaign,
            utm_term:     utms.utm_term,
            utm_content:  utms.utm_content,

            // Meta
            sheetName:    CONFIG.sheetName,
            timestamp:    new Date().toISOString(),
        };
    }

    async function submitToGoogleSheets(formData) {
        const response = await fetch(CONFIG.googleSheetsURL, {
            method: 'POST',
            mode: 'no-cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        });
        console.log('Corp Form: Submitted to Google Sheets → Corporate Leads tab');
        return response;
    }

    function setLoadingState(isLoading) {
        if (elements.submitBtn) elements.submitBtn.disabled = isLoading;
        if (elements.submitText) elements.submitText.style.display = isLoading ? 'none' : 'inline';
        if (elements.submitLoader) elements.submitLoader.style.display = isLoading ? 'flex' : 'none';
    }

    function closeForm() {
        if (elements.overlay) elements.overlay.style.display = 'none';
        setTimeout(() => {
            if (elements.form) { elements.form.style.display = 'flex'; elements.form.reset(); }
            if (elements.successMessage) elements.successMessage.style.display = 'none';
        }, 300);
    }

    function openForm() {
        if (elements.overlay) elements.overlay.style.display = 'flex';
    }

    // ============================================
    // PUBLIC API
    // ============================================
    window.CorpForm = {
        open: openForm,
        close: closeForm,
        setGoogleSheetsURL: function(url) {
            CONFIG.googleSheetsURL = url;
        },
        setThankYouPage: function(url) {
            CONFIG.thankYouPage = url;
        }
    };

    // Initialize
    initForm();

})();
